import { useUser } from "hooks/useUser";
import useQueryCustomerAccount from "ApiLayer/AccountManagement/queryCustomerAccount";

export const useActiveCustomerAccount = () => {
    const { data: user, isFetching: isUserFetching } = useUser();
    const { data: activeCustomerAccount, isFetching: isActiveOrganizationFetching } = useQueryCustomerAccount(
        user?.activeOrganization?.customerAccountUid
    );

    return {
        user,
        activeCustomerAccount,
        isFetching: isUserFetching || isActiveOrganizationFetching,
    };
};
